module.exports = __webpack_public_path__ + "assets/b122.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b122.png
// module id = 595
// module chunks = 0